import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

export const useIsMobile = () => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const isTouch = useMediaQuery("(pointer: coarse)");
	return isSmallScreen || isTouch;
};

export const useIsTablet = () => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down("md"));
};

export const useIsLarge = () => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up("xl"));
};
